import { createSlice } from "@reduxjs/toolkit";
var initialState = { open: false };
export var LoaderSlice = createSlice({ name: "loader", initialState: initialState, reducers: { setLoader: function setLoader(state, action) { state.open = action.payload; } } });
var setLoader = LoaderSlice.actions.setLoader;
export { setLoader };
export default LoaderSlice.reducer;
